import styled from "@emotion/styled";
import { Button, Select } from "react-aria-components";
import { IMDSSelectProps } from "./select.types";

export const StyledSelect = styled(Select)<IMDSSelectProps>``;

export const StyledButton = styled(Button)``;

export const StyledButtonContent = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing["2"]};
`;
